export const CHOSUNG_LIST = [
  'ㄱ',
  'ㄴ',
  'ㄷ',
  'ㄹ',
  'ㅁ',
  'ㅂ',
  'ㅅ',
  'ㅇ',
  'ㅈ',
  'ㅊ',
  'ㅋ',
  'ㅌ',
  'ㅍ',
  'ㅎ',
];

const CHOSUNG_DOUBLE_MAP = {
  ㄲ: 'ㄱ',
  ㄸ: 'ㄷ',
  ㅃ: 'ㅂ',
  ㅆ: 'ㅅ',
  ㅉ: 'ㅈ',
};

export function formatPhoneNumber(number) {
  if (!number) return '';
  const cleaned = number.replace(/\D/g, '');
  if (cleaned.length === 10 || cleaned.length === 11) {
    return cleaned.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3');
  }
  return number;
}

export function getNameInitial(name) {
  const trimmed = (name || '').trim();
  return trimmed ? trimmed[0] : '?';
}

export function getChosungGroup(name) {
  const first = (name || '').trim()[0];
  if (!first) return '기타';

  const code = first.charCodeAt(0);
  if (code >= 0xac00 && code <= 0xd7a3) {
    const chosung = CHOSUNG_LIST[Math.floor((code - 0xac00) / 588)];
    return CHOSUNG_DOUBLE_MAP[chosung] || chosung || '기타';
  }
  if (/[A-Za-z]/.test(first)) return first.toUpperCase();
  if (/[0-9]/.test(first)) return '#';
  return '기타';
}

export function buildSubtitle(item) {
  return [
    item.manageDepartment,
    item.managePosition,
    item.manageQualification,
  ]
    .filter(Boolean)
    .join(' · ');
}

export function filterEmTelList(list, { search = '', department = '' } = {}) {
  const q = (search || '').trim().toLowerCase();

  return (list || []).filter((item) => {
    if (department) {
      const matchDept =
        String(item.manageDepartment || '') === String(department);
      if (!matchDept) return false;
    }

    if (!q) return true;

    return [
      item.manageName,
      item.manageTel,
      item.managePosition,
      item.manageQualification,
      item.manageDepartment,
      item.rank,
    ].some((field) => (field || '').toString().toLowerCase().includes(q));
  });
}

export function groupContactsByChosung(list) {
  const map = new Map();

  (list || []).forEach((item, index) => {
    const manageName =
      item?.manageName ||
      item?.ManageName ||
      item?.name ||
      item?.userNm ||
      item?.USER_NM ||
      '';
    const group = getChosungGroup(manageName) || '기타';
    if (!map.has(group)) map.set(group, []);
    map.get(group).push({
      ...item,
      manageName: manageName || item?.manageName,
      _key: `${group}-${index}-${item?.manageTel || manageName || index}`,
    });
  });

  return [...map.entries()].sort(([a], [b]) => {
    const ga = a || '기타';
    const gb = b || '기타';
    const ai = CHOSUNG_LIST.indexOf(ga);
    const bi = CHOSUNG_LIST.indexOf(gb);
    if (ai !== -1 && bi !== -1) return ai - bi;
    if (ai !== -1) return -1;
    if (bi !== -1) return 1;
    return ga.localeCompare(gb, 'ko');
  });
}

export function extractDepartments(list) {
  return [...new Set((list || []).map((item) => item.manageDepartment).filter(Boolean))];
}

function pickField(row, keys) {
  for (const key of keys) {
    const value = row?.[key];
    if (value != null && String(value).trim()) {
      return String(value).trim();
    }
  }
  return '';
}

export function normalizePhoneDigits(value) {
  return String(value ?? '').replace(/\D/g, '');
}

export function resolveEmTelUserId(item = {}) {
  return pickField(item, [
    'manageId',
    'ManageId',
    'targetUserId',
    'TargetUserId',
    'userId',
    'manageUserId',
    'USER_ID',
    'UserId',
    'id',
  ]);
}

export function resolveMemberUserId(member = {}) {
  return pickField(member, [
    'id',
    'Id',
    'userId',
    'userid',
    'USER_ID',
    'UserId',
    'targetUserId',
    'decUserId',
    'DEC_USER_ID',
  ]);
}

export function normalizeMemberRow(row, index = 0) {
  const name = pickField(row, [
    'name',
    'userNm',
    'USER_NM',
    'UserNm',
    'memNm',
    'MEM_NM',
    'displayName',
    'DISPLAY_NAME',
  ]);
  const id =
    pickField(row, [
      'id',
      'Id',
      'userId',
      'userid',
      'USER_ID',
      'UserId',
      'memId',
      'decUserId',
      'DEC_USER_ID',
    ]) || `${name || 'member'}-${index}`;
  const tel = pickField(row, [
    'tel',
    'phone',
    'manageTel',
    'TEL',
    'PHONE',
    'hp',
  ]);

  return {
    id,
    name,
    position: pickField(row, [
      'position',
      'posNm',
      'POS_NM',
      'PosNm',
      'posiNm',
      'POSI_NM',
      'rank',
      'RANK',
      'jobType',
    ]),
    department: pickField(row, [
      'depNm',
      'depNmLast',
      'DEP_NM_LAST',
      'DepNmLast',
      'manageDepartment',
      'depName',
      'DEP_NM',
    ]),
    depCd: pickField(row, ['depCd', 'DEP_CD', 'DepCd']),
    tel,
  };
}

export function appendCurrentUserToMemberList(memberList = [], userInfo = {}) {
  const list = Array.isArray(memberList) ? [...memberList] : [];
  const myId = String(userInfo.decUserId || userInfo.userid || '');

  if (!myId) return list;

  const alreadyIncluded = list.some((row, index) => {
    const normalized = normalizeMemberRow(row, index);
    return String(normalized.id) === myId;
  });

  if (alreadyIncluded) return list;

  return [
    {
      id: userInfo.decUserId || userInfo.userid,
      name: userInfo.userNm,
      position: userInfo.rank || userInfo.posiNm || '',
      depNm: userInfo.depNm,
      depNmLast: userInfo.depNm,
      depCd: userInfo.depCd,
      tel: userInfo.tel || userInfo.phone || '',
    },
    ...list,
  ];
}

export function filterMembersForAddSheet(
  memberList,
  {
    search = '',
    selectedDepartment = '',
    selectedDepCd = '',
    existingContacts = [],
    departmentScoped = false,
  } = {}
) {
  const q = search.trim().toLowerCase();

  const existingUserIds = new Set(
    (existingContacts || [])
      .map((item) => resolveEmTelUserId(item))
      .filter(Boolean)
  );

  const normalized = (memberList || []).map((row, index) =>
    normalizeMemberRow(row, index)
  );

  const byDepartment = normalized.filter((member) => {
    if (!member.name || !member.id) return false;
    if (departmentScoped) return true;

    if (selectedDepCd && member.depCd) {
      return String(member.depCd) === String(selectedDepCd);
    }

    if (!selectedDepartment) return false;
    if (!member.department) return false;

    return (
      member.department === selectedDepartment ||
      member.department.includes(selectedDepartment) ||
      selectedDepartment.includes(member.department)
    );
  });

  return byDepartment.filter((member) => {
    if (member.id && existingUserIds.has(member.id)) return false;

    if (!q) return true;

    return [member.name, member.position, member.department].some((field) =>
      (field || '').toLowerCase().includes(q)
    );
  });
}
